import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import EventFormContainer from '../containers/EventFormContainer';
import EventsDetailsListContainer from '../containers/EventsDetailsListContainer';

import { getIsEventsShown } from '../../Navigation/utils';

import Route from '../../../routes/SentryRoute';
import TabsComponentWithLinks from '../../Tabs/TabsComponentWithLinks';
import EventDetailsRouter from './EventDetailsRouter';

const EventsRouter = () => {
  const { path, url } = useRouteMatch();

  const location = useLocation();

  const firstLineTabs = [
    {
      label: 'Events',
      url: `${url}/details`,
    },
  ];

  if (!getIsEventsShown()) return <Redirect to="/404" />;

  return (
    <>
      <TabsComponentWithLinks
        tabData={firstLineTabs}
        currentUrl={location.pathname}
      />
      <Switch>
        <Route
          path={`${path}/details`}
          component={EventsDetailsListContainer}
          exact
        />
        <Route path={`${path}/:id`} component={EventFormContainer} exact />
        <Route path={`${path}/details/:id`} component={EventDetailsRouter} />
        <Route path={`${path}`}>
          <Redirect to={`${url}/details`} />
        </Route>
      </Switch>
    </>
  );
};

export default EventsRouter;
